module.exports = __webpack_public_path__ + "static/media/3.1de3890f.svg";